import { CognitoUserPool } from 'amazon-cognito-identity-js';

const poolData = {
    UserPoolId: 'us-west-2_N2eDO2isW',
    ClientId: '40gu7m7eioh3q3vcec84kof5db'
};

export default new CognitoUserPool(poolData);